import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default class Form extends PureComponent{
    constructor(props){
        super(props);

        this.onSubmit=this.onSubmit.bind(this);
        this.attachToForm=this.attachToForm.bind(this);
        this.removeFromForm=this.removeFromForm.bind(this);
    }
    componentWillMount(){
        this.inputs=[];
    }
    componentWillUnmount(){
        this.inputs=[];
    }
    getChildContext(){
        return {
            Form:{
                attachToForm:this.attachToForm,
                removeFromForm:this.removeFromForm
            }   
        };
    }
    removeFromForm(input){
        const index = this.inputs.indexOf(input);
        if(index > -1){
            this.inputs.splice(index,1);
        }
    }
    onSubmit(ev){
        ev.preventDefault();

        let invalid = !!this.inputs.find(input=>!input.isValid());
        if(invalid){
            return this.inputs.forEach(input=>input.touch());
        }

        this.inputs.forEach(input=>input.reset());
        if(this.props.onSubmit) this.props.onSubmit();
    }
    isValid(){
        return !this.inputs.find(input=>!input.isValid());
    }
    attachToForm(input){
        if(this.inputs.indexOf(input) === -1){
            this.inputs.push(input)
        }
    }
    render(){
        const formClasses = classNames({
            "cl-form":true,
            [this.props.className]:!!this.props.className
        })
        return(
            <form onSubmit={this.onSubmit} className={formClasses} noValidate>
                {this.props.children}
            </form>
        )
    }
}

Form.childContextTypes= {
    Form: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/Form.js